import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { MdArrowForwardIos } from "react-icons/md";
import { BookOverview1 } from '../../bookOverviews/bookOverview';

export const OrderDetails = ({data}) => {

  const navigate = useNavigate()
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (id) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <div className="flex flex-col gap-5 shadow-lg p-10 w-full box-border">
      <h2 className="text-sm md:text-base font-bold">Ordrerbekræftelse</h2>
        <div className="products flex flex-col">
          <table class="table-auto w-full text-left hidden md:inline-table">
              <thead className="text-sm">
                <tr>
                  <th className="pb-4 font-semibold">Bøger</th>
                  <th className="pb-4 px-10 font-semibold hidden xl:table-cell">Sælger</th>
                  <th className="pb-4 px-10 font-semibold hidden lg:table-cell">Levering/Afhenting</th>
                  <th className="pb-4 sr-only">Se detaljer</th>
                </tr>
              </thead>
              <tbody className="text-base">
                {data.map((ss) => ss.products.map((book) => {
                  return (
                    <tr className="border-t">
                      <td className="py-4 flex gap-2 flex-wrap">
                        <BookOverview1 book={book} />
                      </td>
                      <td className="py-4 px-10 whitespace-nowrap hidden xl:table-cell">{ss.seller.first_name} {ss.seller.last_name}</td>
                      <td className="py-4 px-10 whitespace-nowrap hidden lg:table-cell">{ss.deliveryType === 1 ? "Leveres til pakkeshop" : ss.deliveryType === 2 ? "Hjemmelevering" : "Afhentes hos sælger"}</td>
                      <td className="py-4 px-10">
                        <div className="whitespace-nowrap ml-auto px-5 py-2 w-fit ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                            Se status
                        </div>
                      </td>
                    </tr>
                  )
                }))}
              </tbody>
          </table>
          <div className="flex flex-col md:hidden gap-5 mb-5">
              {data.map((ss, index) => {
                  return (
                      <>
                      <hr></hr>
                          <div className="flex flex-col gap-5">
                              <div className="flex flex-col gap-2">
                                  <div className="flex gap-2 items-center cursor-pointer w-fit" onClick={() => toggleDropdown(ss._id)}>
                                      <h2 className="font-medium">Antal bøger:</h2>
                                      <div className="flex gap-2 items-center">
                                          <p>{ss.products.length}</p>
                                          <MdArrowForwardIos style={{
                                              transform: openDropdowns[ss._id] ? 'rotate(90deg)' : 'rotate(0deg)',
                                              transition: 'transform 0.3s ease',
                                          }} />
                                      </div>
                                  </div>
                                  <div className="flex gap-2" 
                                      style={{
                                      maxHeight: openDropdowns[ss._id] ? '200px' : '0',
                                      overflow: 'hidden',
                                      transition: 'max-height 0.3s ease',
                                  }}>
                                      {ss.products.map((book) => 
                                          <div className="bookImage aspect-square w-16 h-16 bg-neutral-100 cursor-pointer">
                                              <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
                                          </div>
                                      )}
                                  </div>
                                  <div className="flex gap-x-2 items-center flex-wrap">
                                    <h2 className="font-medium">Sælger:</h2>
                                    <p>{ss.seller.first_name} {ss.seller.last_name}</p>
                                  </div>
                                  <div className="flex gap-x-2 items-center flex-wrap">
                                    <h2 className="font-medium">Levering/Afhentning:</h2>
                                    <p>{ss.deliveryType === 1 ? "Leveres til pakkeshop" : ss.deliveryType === 2 ? "Hjemmelevering" : "Afhentes hos sælger"}</p>
                                  </div>
                              </div>
                              <div className="text-center px-5 py-2 w-full ring-1 ring-emerald-600 cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/ordre?id=${ss._id}`)}>
                                  Se status
                              </div>
                          </div>
                      </>
                  )
              })}
          </div>
          <hr></hr>
        </div>
        <div className="overview flex flex-col gap-y-2">
          <div className="font-normal">
              <div className="flex border-box">
                  <p className="grow">Subtotal</p>
                  <p>{(Number(data.flatMap((ss) => ss.products.map((book) => book.dbBook.price)).reduce((acc, price) => acc + price, 0)) / 100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
              </div>
              {(data.some(a => a.deliveryType !== 3)) ? 
                  <div className="flex border-box items-center">
                      <p className="grow">Fragt</p>
                      <p className="">{(Number(data.map((ss) => ss.deliveryType !== 3 ? ss.deliveryDetails.price : 0).reduce((acc, price) => acc + price, 0))).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                  </div>
              :
                  ""}
              <div className="flex border-box">
                  <p className="grow">Gebyr</p>
                  <p>{((Number(data.flatMap((ss) => ss.products.map((book) => book.dbBook.price)).reduce((acc, price) => acc + price, 0)) / 100) * 0.1).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
              </div>
          </div>
          <div className="total">
              <div className="flex border-box font-bold">
                  <p className="grow">I alt</p>
                  <p>{((Number(data.flatMap((ss) => ss.products.map((book) => book.dbBook.price)).reduce((acc, price) => acc + price, 0)) / 100)+((Number(data.flatMap((ss) => ss.products.map((book) => book.dbBook.price)).reduce((acc, price) => acc + price, 0)) / 100) * 0.1)+(Number(data.map((ss) => ss.deliveryType !== 3 ? ss.deliveryDetails.price : 0).reduce((acc, price) => acc + price, 0)))).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
              </div>
          </div>
        </div>
    </div>
  )
}